import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EventState {
  selectedLanguages: string[];
}

const initialState: EventState = {
  selectedLanguages: ["bg", "en"],
};

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setSelectedLanguages: (state, action: PayloadAction<string[]>) => {
      state.selectedLanguages = action.payload;
    },
  },
});

export const { setSelectedLanguages } = eventSlice.actions;

export default eventSlice.reducer;
